/**
 * SplashIntro — 메인 첫 진입 시 인트로 연출 (GSAP 타임라인 + 커튼)
 * - 로고·상단 문구: 아래→위 등장
 * - 슬로건: 제자리에서 글자별 랜덤 opacity 0→1
 * - 30분 쿠키로 새로고침 시 인트로 생략 (FORCE_SHOW_INTRO로 데모 시 항상 표시)
 */

const COOKIE_NAME = "splash_seen";
const COOKIE_MINUTES = 30;

/** 디자인 수정용: true면 인트로 애니/인터랙션 없이 스플래시만 정적으로 덮어둠 (수정 후 false로 복구) */
export const SPLASH_DESIGN_MODE = false;

/** 고객 데모 시 true → 쿠키 무시하고 항상 인트로 재생 */
export const FORCE_SHOW_INTRO = true;

function getCookie(name) {
    const match = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/[^\\w]/g, "\\$&") + "=([^;]*)"),
    );
    return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, minutes) {
    const d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 1000);
    document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        "; path=/; expires=" +
        d.toUTCString() +
        "; SameSite=Lax";
}

function hideSplash(el) {
    if (!el) return;
    el.classList.add("is-done");
    el.setAttribute("aria-hidden", "true");
    // window.scrollTo(0, 0);
    window.dispatchEvent(new CustomEvent("splashEnded"));
}

function wrapSloganInChars(sloganEl) {
    if (!sloganEl) return [];
    const text = (sloganEl.textContent || "").trim();
    sloganEl.textContent = "";
    const chars = text.split("");
    const spans = [];
    chars.forEach((char) => {
        const span = document.createElement("span");
        span.className = "no-splash-mask__slogan-char";
        span.textContent = char === " " ? "\u00A0" : char;
        span.style.opacity = "0";
        sloganEl.appendChild(span);
        spans.push(span);
    });
    return spans;
}

function shuffleArray(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

export function initSplashIntro() {
    const el = document.getElementById("splash-mask");
    if (!el) return;

    if (SPLASH_DESIGN_MODE) {
        return;
    }

    const brand = el.querySelector("[data-splash-brand]");
    const logo = el.querySelector("[data-splash-logo]");
    const nameEl = el.querySelector("[data-splash-name]");
    const sloganEl = el.querySelector("[data-splash-slogan]");

    if (!FORCE_SHOW_INTRO && getCookie(COOKIE_NAME)) {
        hideSplash(el);
        return;
    }

    const gsap = window.gsap;
    if (!gsap) {
        hideSplash(el);
        return;
    }

    const sloganChars = wrapSloganInChars(sloganEl);
    const CURTAIN_DURATION = 1.1;

    gsap.set([brand, logo, nameEl], { opacity: 0, y: 32 });
    gsap.set(sloganChars, { opacity: 0 });

    const tl = gsap.timeline({ onComplete: finish });

    tl.to([brand, logo, nameEl], {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power3.out",
        stagger: 0.06,
    });

    const shuffled = shuffleArray(sloganChars);
    tl.to(
        shuffled,
        {
            opacity: 1,
            duration: 0.4,
            stagger: { each: 0.075, from: "random" },
            ease: "power2.out",
        },
        "-=0.2",
    );

    tl.add(() => {
        el.classList.add("is-open");
    }, "+=0.5");

    function finish() {
        // 커튼 열림 애니메이션 종료 후 메인 비주얼로 전환
        setTimeout(
            () => {
                setCookie(COOKIE_NAME, "1", COOKIE_MINUTES);
                el.classList.add("is-done");
                el.setAttribute("aria-hidden", "true");
                // window.scrollTo(0, 0);
                window.dispatchEvent(new CustomEvent("splashEnded"));
            },
            CURTAIN_DURATION * 1000 + 50,
        );
    }
}
